export default function initClearableFlashes() {
  document.querySelectorAll("[data-clear-flash]").forEach(function (item) {
    const alert = item.parentNode;
    item.addEventListener("click", () => {
      alert.style.height = `${alert.getBoundingClientRect().height}px`;
      alert.className += " alert--hidden";
      alert.addEventListener("transitionend", () => {
        alert.parentNode && alert.parentNode.removeChild(alert);
      });
    });

    setTimeout(() => {
      item.click();
    }, 3000);
  });
}
